module.exports = __webpack_public_path__ + "img/sleeve_length.f9f9fad3.png";